import type { Theme } from "@mui/material/styles";

import { actionSecondary } from "./action.styles";

type Styles = Record<string, any>;

/** Canonical page-panel chrome: container surface, black border, 16px radius, light shadow. */
export const surfacePanel = (theme: Theme): Styles => ({
  backgroundColor: theme.design.color.surface.container,
  color: theme.design.color.text.primary,
  border: `1px solid ${theme.design.color.border.black}`,
  borderRadius: theme.design.radius.xl,
  boxSizing: "border-box" as const,
  boxShadow: theme.design.shadow.sm,
});

/** Nested boxes inside a page panel. */
export const surfaceRaised = (theme: Theme): Styles => ({
  backgroundColor: theme.design.color.surface.raised,
  color: theme.design.color.text.primary,
  border: `1px solid ${theme.design.color.border.black}`,
  borderRadius: theme.design.radius.xl,
  boxSizing: "border-box" as const,
});

/** Quiet control buttons on a panel. Prefer actionSecondary for new call sites. */
export const surfaceSubtleButton = actionSecondary;
